import { CommonModule } from "@angular/common";
import { Component, OnInit, signal } from "@angular/core";
import { Router } from "@angular/router";
import { FUNCTION_RESULT_STATUS, IPlatformUser } from "@nova/common-interfaces";
import { BlockUIModule } from "ng-block-ui";
import { ConfirmationService, MenuItem, MessageService } from "primeng/api";
import { ButtonModule } from "primeng/button";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { MenuModule } from "primeng/menu";
import { TableModule } from "primeng/table";
import { TabMenuModule } from "primeng/tabmenu";
import { ToastModule } from "primeng/toast";
import { SystemPlatformUserService } from "../../../../shared/services/auth/system-platform-user.mjs";

@Component({
  selector: "app-settings-platform-users",
  standalone: true,
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    BlockUIModule,
    TabMenuModule,
    MenuModule,
    ConfirmDialogModule,
    ToastModule,
  ],
  providers: [ConfirmationService, MessageService],
  templateUrl: "./settings-platform-users.component.html",
  styleUrls: ["./settings-platform-users.component.scss"],
})
export class SettingsPlatformUsersComponent implements OnInit {
  users: IPlatformUser[] | undefined;
  filtered_users: IPlatformUser[] = [];
  activeItem: IPlatformUser | undefined;
  row_items: MenuItem[] = [];
  activeTab: any;
  activeTabLabel: string = "active";
  objectId = signal('');

  items: MenuItem[] = [
    {
      label: 'View',
      icon: 'pi pi-file',
      command: () => this.view(this.activeItem!.id),
    },
    {
      label: 'View Customer',
      icon: 'pi pi-file-plus',
      command: () => this.viewCustomer(this.selectedUser!.customers.data[0].id),
    },
  ];

  view(id: string)
  {

  }

  viewCustomer(id: string) {
    this.router.navigate(['admin/customers/view', id]);
  }

  tabs: MenuItem[] = [
    { label: "Active", command: () => this.setActiveTab("active") },
    { label: "Due", command: () => this.setActiveTab("due") },
    { label: "Inactive", command: () => this.setActiveTab("inactive") },
    { label: "Suspended", command: () => this.setActiveTab("suspended") },
    { label: "Cancelled", command: () => this.setActiveTab("cancelled") },
  ];

  setActiveTab(label: string) {
    this.activeTabLabel = label;
    this.applyFilter();
  }

  applyFilter() {
    this.filtered_users = this.users!;
  }

  selectedUser: IPlatformUser | undefined;

  menuClicked(rowData: any) {
    this.activeItem = rowData;
    this.row_items = [];

    this.items.forEach((item) => {
      switch (item.id) {
        case 'suspend':
          if (this.activeItem?.is_active) {
            this.row_items.push(item);
          }
          return item;
          case 'activate':
            if (!this.activeItem?.is_active) {
              this.row_items.push(item);
            }
            return item;
        case 'change_price':
          if (this.activeItem?.is_active) {
            this.row_items.push(item);
          }
          return item;
        case 'change_plan':
          if (this.activeItem?.is_active) {
            this.row_items.push(item);
          }
          return item;
        default:
          this.row_items.push(item);
          return item;
      }
    });
    
    this.objectId.set(rowData.id);
  }
  
  constructor(private platformUserServices: SystemPlatformUserService, private router: Router) {}

  ngOnInit() {
    this.platformUserServices.getAll().then((result) => {
      if (result.status === FUNCTION_RESULT_STATUS.SUCCESS) {
        this.users = result.data;
        this.applyFilter();
      }
    });
  }
}
